<div class="form-input-with-icon">
    <mat-form-field [color]="color" [appearance]="outlined" [ngStyle]="{'maxWidth': maxWidth, 'width': width}">
        <mat-label>{{text}}</mat-label>
        <input matInput [type]="type" [name]="name" [formControlName]="formControlName" placeholder="" [disabled]="disabled">
        <mat-icon [ngClass]="{'material-icons-outlined': iconOutlined}" matSuffix>{{ngControl.disabled || disabled ? 'lock' : icon}}</mat-icon>
        <mat-hint *ngIf="hintText">{{hintText}}</mat-hint>
        <mat-error *ngIf="errorMsg">{{errorMsg}}</mat-error>
    </mat-form-field>
</div>